<template>
    <div class="pages newCoupons">
        
        <div class="content">
            <div class="tabw">
                <div class="title mb-30">
                    <p>
                        <img src="../../assets/images/newIcon/margetmiddleadd_basicsetup_icon2.png" alt="">
                        <span>基本设置</span>
                    </p>
                    <p>
                    </p>
                </div>
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="优惠券名称：" prop="name" :rules="{
                    required: true, message: '请输入优惠券名称', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" placeholder="请输入优惠券名称"></el-input>
                    </el-form-item>
                    <el-form-item label="名称备注：" prop="desc">
                        <el-input maxlength="10" placeholder="仅内部可见，最多10个字" :rows="8"  resize="none" v-model="form.desc"></el-input>
                    </el-form-item>
                     <el-form-item label="发放总量：" prop="name" :rules="{
                    required: true, message: '请输入发放总量', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" placeholder="最多10000000000张"></el-input>
                        <p class="tips"><i>*</i> 修改优惠券总量时只能增加不能减少，请谨慎设置</p>
                    </el-form-item>
                   
                </el-form>
            </div>
            <div class="tabw">
                <div class="title mb-30">
                    <p>
                        <img src="../../assets/images/newIcon/margetmiddleadd_rulesset_icon.png" alt="">
                        <span>规则设置</span>
                    </p>
                    <p>
                    </p>
                </div>
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="优惠券类型:" :rules="{
                    required: true
                    }">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">满减券</el-radio>
                            <el-radio label="2">折扣券</el-radio>
                            <el-radio label="3">代金券</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="form.type==1" label="使用门槛：" prop="name" :rules="{
                    required: true, message: '请输入优惠券名称', trigger: 'blur'
                    }">
                        <p class="mj">
                            <span>满</span>
                            <el-input v-model="form.name" placeholder="请输入金额"></el-input>
                            <span>元</span>
                            <span>减</span>
                            <el-input v-model="form.name" placeholder="请输入金额"></el-input>
                            <span>元</span>
                        </p>
                    </el-form-item>
                    <el-form-item v-if="form.type==2" label="使用门槛：" prop="name" :rules="{
                    required: true, message: '请输入优惠券名称', trigger: 'blur'
                    }">
                        <p class="mj">
                            <span>满</span>
                            <el-input v-model="form.name" placeholder="请输入金额"></el-input>
                            <span>元</span>
                            <span>打</span>
                            <el-input v-model="form.name" placeholder="请输入1-10"></el-input>
                            <span>折</span>
                        </p>
                    </el-form-item>
                    <el-form-item v-if="form.type==3" label="使用门槛：" prop="name" :rules="{
                    required: true, message: '请输入优惠券名称', trigger: 'blur'
                    }">
                        <p class="mj">
                            <span>立减</span>
                            <el-input v-model="form.name" placeholder="请输入金额"></el-input>
                            <span>元</span>
                        </p>
                    </el-form-item>
                     <el-form-item label="发放渠道：" prop="name" :rules="{
                    required: true, message: '请输入发放总量', trigger: 'blur'
                    }">
                        <!-- <el-input v-model="form.name" placeholder="最多10000000000张"></el-input> -->
                         <el-select class="iptRdio" v-model="value" placeholder="请选择会员来源">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <p class="tips" style="padding-bottom:0;"><i>*</i> 创建成功后可在业务系统进行配置</p>
                    </el-form-item>
                     <el-form-item label="发放方式:" :rules="{
                    required: true
                    }">
                        <el-radio-group v-model="form.fftype">
                            <el-radio label=1>活动发放</el-radio>
                            <el-radio label=2>用户领取</el-radio>
                            <el-radio label=3>等级发放</el-radio>
                        </el-radio-group>
                         <p class="tips" v-if="form.fftype==1"><i>*</i> 创建营销活动时可选择</p>
                         <p class="tips" v-if="form.fftype==2"><i>*</i> 自动进入用户领券大厅自动领取</p>
                         <p class="tips" v-if="form.fftype==3"><i>*</i> 设置用户等级时可选择</p>
                    </el-form-item>
                </el-form>
            </div>
            <span v-if="types==1" class="footer">
                <el-button class="quxiao" @click="handleClose" >取 消</el-button>
                <el-button type="primary"  @click="goType(2)">保 存</el-button>
                <!-- <el-button type="primary" v-if="types==3" @click="goType(2)">完成</el-button> -->
            </span>
        </div>
        <customer-popup @doSelect='doSelect' ref="customerPopup"></customer-popup>
    </div>
</template>

<script>
export default {
    data() {
        return {
            types:1,
            
            form: {
            fftype:1,
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: "3",
            resource: '1',
            desc: ''
            },
            value:"健康红梅"
        }
    },
    methods: {
        doSelect(){

        },
         showPopup(type){
            this.$refs.customerPopup.show(type);
        },
        createds(val){
            console.log(val,111111)
            if(val.type==1){
                this.types=--this.types;
            }
        },
        goType(type){
            // this.types=type;
            this.$message({
            message: '保存成功',
            type: 'success'
            });
            this.$router.go(-1)
            
        },
        handleClose(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="less" scoped>
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .content{
        // padding:30px;
        background: #fff;
        .checkTab{
            background: #fff;
            padding:60px 0;
            display: flex;
            justify-content: center;
            border-radius: 6px;
            li{
                display: flex;
                align-items: center;
                margin-right:220px;
                position: relative;
                &:last-child{
                    margin:0;
                    &::after{
                        left: -206px;
                    }
                }
                &:first-child{
                    
                    &::after{
                        display:none;
                    }
                    
                }
                &:nth-child(2){
                    &::after{
                        left: -205px;
                    }
                    
                }
                
                &::after{
                    content: '';
                    position: absolute;
                    top: 30px;
                    border-bottom: 1px dashed #A7A7A7;
                    width: 190px;
                    height: 2px;
                }
            }
            .active{
                &::after{
                    border-bottom: 1px dashed #327EFF;
                }
                p{
                    &:last-child{
                        color: #327EFF;
                    }
                    &:first-child{
                        background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                        color:#fff;
                    }
                    span{
                        &:first-child{
                            color:#327EFF;
                        }
                        &:last-child{
                            color:#484848;
                        }
                    }
                }
            }
            p{
                // text-align: center;
                &:first-child{
                    margin:0 auto;
                    margin-right:20px;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    line-height: 64px;
                    text-align: center;
                    background: #EBEBEB;
                    font-size: 34px;
                    font-weight: 500;
                    color: #fff;
                }
                &:last-child{
                    font-size: 14px;
                    font-weight: 400;
                    color: #A1A1A1;
                    span{
                        display: block;
                        color: #999990;
                        &:first-child{
                            margin-bottom:10px;
                            font-size: 20px;
                            font-weight: 500;
                            
                        }
                    }
                }
            }
        }
        .tabw{
            width:45%;
            padding:30px;
            padding-bottom:0;
            border-radius: 6px;
            background: #fff;
            .el-form{
                padding-right:5%;
                 border-bottom:1px solid #E9E9E9;
            }
            .tips{
                padding:15px 0;
                font-size: 12px;
                font-weight: 400;
                color:#999;
                i{
                     color: #E02020;
                }
            }
            // /deep/ .el-select{
            //     width:300px;
            // }
            .mj{
                display: flex;
                /deep/ .el-input{
                    width:100px;
                }
                span{
                    padding:0 10px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            // .el-form{
            //     width:60%;
            // }
            .el-select{
                // width:100%;
            }
            /deep/.el-textarea .el-textarea__inner{
                // width:100%;
                border:0;
                background:#F6F6F6;
            }
            /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
            .min_ipt{
                margin:0 10px;
                width:100px;
            }
            .liex{
                margin-top:15px;
                font-size: 10px;
                font-weight: 400;
                color: #999;
                i{
                    color: #E02020;
                }
            }
            .el-form-item{
                margin-bottom:30px;
            }
        }
        /deep/ .el-tag{
            border-radius: 30px;
            margin-right:10px;
            margin-bottom:10px;
        }
        .imgs{
            width:16px;
            vertical-align: middle;
            margin-left:10px;
        }
        .footer{
            display: block;
            background: #fff;
            padding:15px 30px;
            border-top:1px solid #ededed;
            .el-button{
                border-radius: 30px;
            }
        }
    }
</style>